import { createSvgIcon } from '@mui/material';

const IconInvoice = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="27.223"
    height="34.319"
    viewBox="0 0 27.223 34.319"
  >
    <g id="Group_4092" data-name="Group 4092" transform="translate(-153.613 132.894)">
      <path
        id="Path_2595"
        data-name="Path 2595"
        d="M5,34.932V6.548A3.548,3.548,0,0,1,8.548,3h17.74a3.548,3.548,0,0,1,3.548,3.548V34.932l-5.322-3.548-3.548,3.548-3.548-3.548L13.87,34.932l-3.548-3.548L5,34.932"
        transform="translate(150 -134.894)"
        fill="none"
        stroke="#6ace3b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        id="Path_2596"
        data-name="Path 2596"
        d="M17.1,9.161H12.661a2.661,2.661,0,0,0,0,5.322h1.774a2.661,2.661,0,0,1,0,5.322H10m3.548,0v2.661m0-15.966V9.161"
        transform="translate(153.87 -132.185)"
        fill="none"
        stroke="#6ace3b"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
  </svg>,
  'IconInvoice',
);

export default IconInvoice;
